// store/store.ts
import { configureStore } from '@reduxjs/toolkit';
import categoryNavigationReducer from './navigationSlice';
import staticSettingSlice from './staticSettingSlice';
import getPlatformSlice from './getPlatformDevice';
import authReducer from './authSlice';

export const store = configureStore({
  reducer: {
    categoryNavigation: categoryNavigationReducer,
    staticSettingSlice: staticSettingSlice,
    getPlatformSlice: getPlatformSlice,
    auth: authReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;